import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27.3215 19.904C25.3582 20.4545 23.2837 20.4725 21.3111 19.9562C19.3385 19.4399 17.5388 18.4078 16.097 16.966C14.6552 15.5242 13.6231 13.7245 13.1068 11.7519C12.5904 9.77929 12.6085 7.70479 13.159 5.74146C11.2234 6.28022 9.46264 7.31673 8.05222 8.74775C6.6418 10.1788 5.63092 11.9543 5.12027 13.8976C4.60963 15.8409 4.61703 17.884 5.14175 19.8236C5.66647 21.7631 6.69019 23.5313 8.11095 24.952C9.5317 26.3728 11.2999 27.3965 13.2394 27.9212C15.1789 28.446 17.2221 28.4534 19.1654 27.9427C21.1087 27.4321 22.8842 26.4212 24.3152 25.0108C25.7463 23.6004 26.7828 21.8396 27.3215 19.904Z",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMoon;
